<!-- <div  class="d-flex flex-column justify-content-center"></div> -->
<div class="">
  <swiper-container
    #swiper1
    style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff;"
    class="mySwiper"
    thumbs-swiper=".mySwiper2"
    navigation="true"
    init="false"
  >
    <swiper-slide *ngFor="let slide of slides">
      <div class="">
        <div *ngIf="slide.type == 'jpeg';then jpeg else base64">here is ignored</div>
      <ng-template #jpeg>  <img [src]="slide.image" /> </ng-template>
      <ng-template #base64> <img src="{{'data:image/jpg;base64,' + slide.image}}" /> </ng-template>
    </div>
    </swiper-slide>
  </swiper-container>

  <swiper-container
    #swiper2
    class="mySwiper2"
    slides-per-view="3"
    space-between="10"
    free-mode="true"
    init="false"
  >
    <swiper-slide *ngFor="let slide of slides">
      <div *ngIf="slide.type == 'jpeg';then jpeg else base64">here is ignored</div>
          <ng-template #jpeg>  <img [src]="slide.image" /> </ng-template>
          <ng-template #base64> <img src="{{'data:image/jpg;base64,' + slide.image}}" /> </ng-template>
    </swiper-slide>
  </swiper-container>
  <div class="proof_detail"> 

    <div class="column-list">
      <div class="column-item">
        <span> {{'p_proof_con_no'|translate}}</span>
        <span>{{consignmentNo}} </span>
      </div>
      <div class="column-item">
        <span> {{'p_proof_location'|translate}} </span> 
        <span>   {{descLocation}} </span>
      </div>
      <button class="ke-btn-primary ke-background-primary text-1216" style="padding: 3px 40px;color: white; "
      mat-dialog-close type="button">
        <span>{{'g.close'|translate}}</span>
      </button>
    </div>
  </div>

</div>

